import { create } from "zustand";
import { api, type KpiEntry, type UpsertKpiInput } from "../lib/tauri";

interface KpiState {
  /** 今日の全エントリ（プロジェクト横断。KpiChips が projectId で絞る） */
  entries: KpiEntry[];
  load: () => Promise<void>;
  upsert: (input: UpsertKpiInput) => Promise<void>;
}

export const useKpiStore = create<KpiState>((set, get) => ({
  entries: [],
  load: async () => {
    try {
      const entries = (await api.kpiList?.()) ?? [];
      set({ entries });
    } catch {
      set({ entries: [] }); // PWA 等未対応環境
    }
  },
  upsert: async (input) => {
    await api.kpiUpsert?.(input); // エラーは呼び出し側でトースト
    await get().load();
  },
}));
